export default "__VITE_ASSET__CCbrOUVS__"